carouselIntervalInstance = null

module.exports = class HomepageCarousel
  constructor: ({@carouselConfig, @showFreeShippingModal, @inGoodsHomepageSSR}={}) ->
    @widget = $("#carousel-widget")
    @wrapper = @widget.find("#carousel-wrapper")
    @length = @wrapper.children().length-1
    @index = 0
    @advance = true

    if @carouselConfig?
      {@carouselInterval, @numOfSlots, showSubnavWidget, @overlayControls,
      @maxNumOfMenuItems, @maxNumOfMenuCols, @moreCategoriesId} = @carouselConfig
      @maxNumOfSubnavItems = @numOfSlots
      if showSubnavWidget
        @maxNumOfSubnavItems = @numOfSlots - 1

    @menuItemHeight = 28
    @menuTopPadding = 3
    @moreCategoriesLabel = I18n.translate 'js.modules.home.more_categories'

    if @showFreeShippingModal
      @_loadFreeShippingModal()

    if not @inGoodsHomepageSSR
      if $("#homepage-header").length and $("#homepage-header-temp").length
        $("#homepage-header-temp").children().appendTo("#homepage-header")

    if @widget.length
      if @_hasNoControls()
        $("#homepage-header").addClass('carousel-height-no-controls')
      else
        $("#homepage-header").addClass('carousel-height')

    if @widget.length
      @_initializeCarousel()
      unless $('html').hasClass 'lt-ie9' and @wrapper.children().length > 1
        carouselIntervalInstance = setTimeout(@_startCarousel, @carouselInterval)
      @_loadControls()
      @_loadSubnav()

  _hasNoControls: () ->
    @wrapper.children().length == 1 or @overlayControls

  _initializeCarousel: () ->
    child = @wrapper.children().get(0)
    if child
      $(child).css("opacity", 1).css("display", "block")

    circles = @widget.find(".icon-circle")
    if circles.length
      $(circles[0]).addClass("selected")

  _startCarousel: () =>
    @_advanceCarousel("right")
    carouselIntervalInstance = setTimeout(@_startCarousel, @carouselInterval)

  _advanceCarousel: (direction) ->
    prevIndex = @index
    @_incrementIndex direction

    if prevIndex != @index
      @_showSlide prevIndex, @index
      @_showCircle prevIndex, @index

  _jumpCarousel: (from, to) ->
    if from != to
      @_showSlide from, to
      @_showCircle from, to
      @index = to

  _stopCarousel: ->
    carouselIntervalInstance = window.clearInterval(carouselIntervalInstance)

  _incrementIndex: (direction) ->
    if direction is 'right'
      @index += 1
      if @index > @length
        @index = 0
    else
      @index -= 1
      if @index < 0
        @index = @length

  _showSlide: (from, to) ->
    if from != to
      children = @wrapper.children()
      from = $(children.get(from))
      to = $(children.get(to))
      from.fadeTo('fast', 0)
      to.fadeTo('fast', 1)
      from.hide()

  _showCircle: (from, to) ->
    if from != to
      circles = @widget.find(".icon-circle")
      if circles.length
        $(circles[from]).removeClass("selected")
        $(circles[to]).addClass("selected")

  _loadFreeShippingModal: ->
    if window.GIG
      window.GIG.init()

  _loadControls: ->
    $('.homepage-carousel-left').on 'click', (e) =>
      @advance = false
      @_stopCarousel()
      @_advanceCarousel 'left'

    $('.homepage-carousel-right').on 'click', (e) =>
      @advance = false
      @_stopCarousel()
      @_advanceCarousel 'right'

    $('.carousel-item, .nav-bar-item, .menu').on 'mouseenter', (e) =>
      @_stopCarousel()

    $('.carousel-item, .nav-bar-item, .menu').on 'mouseleave', (e) =>
      @_stopCarousel()

      if @advance
        carouselIntervalInstance = setTimeout(@_startCarousel, @carouselInterval)

    $('.icon-circle').on 'click', (e) =>
      to = parseInt(e.target?.attributes?.getNamedItem("index")?.value, 10)
      from = @index

      if from != to
        @_stopCarousel()
        @_jumpCarousel from, to

  _numOfCols: (numOfItems) ->
    return Math.ceil(numOfItems / @maxNumOfMenuItems)

  _numOfItemsPerCol: (numOfItems, numOfCols) ->
    return Math.ceil(numOfItems / numOfCols)

  _flyoutPosition: (navBarItemPos, numOfItemsPerCol) ->
    pos = if numOfItemsPerCol <= 1 then 0 else Math.floor(numOfItemsPerCol / 2) - 1
    return if pos > navBarItemPos then navBarItemPos else pos

  _indexStartingFromEnd: (navBarItemPos) ->
    return (@numOfSlots - 1) - navBarItemPos

  _calculateMenuTop: (flyoutPosition) ->
    return (@menuItemHeight * flyoutPosition) + @menuTopPadding

  _setMenuTop: (menu, menuHoverContainer, menuTop) ->
    menu.css('top', -menuTop + 'px')
    menuHoverContainer.css('top', -menuTop + 'px')

  _repositionMenu: (menu, menuHoverContainer, navBarItemPos, numOfItemsPerCol) ->
    flyoutPosition = @_flyoutPosition navBarItemPos, numOfItemsPerCol
    menuTop = @_calculateMenuTop flyoutPosition
    if navBarItemPos < (@numOfSlots / 2)
      if flyoutPosition <= navBarItemPos
        @_setMenuTop menu, menuHoverContainer, menuTop
    else
      newFlyoutPos = (numOfItemsPerCol - 1) - flyoutPosition
      newNavBarItemPos = @_indexStartingFromEnd navBarItemPos
      if newFlyoutPos > newNavBarItemPos
        flyoutPosition = (numOfItemsPerCol - 1) - newNavBarItemPos
        menuTop = @_calculateMenuTop flyoutPosition
      @_setMenuTop menu, menuHoverContainer, menuTop
    menu.addClass('flyout-pos' + flyoutPosition)

  _updateMenuWidth: (menu, numOfCols) ->
    if numOfCols > @maxNumOfMenuCols
      numOfCols = @maxNumOfMenuCols
    menu.addClass('columns-' + numOfCols)

  _createCol: (colNum, menu, numOfItemsPerCol, menuItems) ->
    menu.append("<div class='menu-column'><ul></ul></div>")
    column = menu.find("ul")[colNum]
    colStart = colNum * numOfItemsPerCol
    colEnd = colStart + numOfItemsPerCol
    for menuItem in menuItems.slice(colStart, colEnd)
      $(column).append(menuItem)

  _createCols: (numOfCols, menu, numOfItemsPerCol, menuItems) ->
    for i in [0..numOfCols-1] by 1
      if i == @maxNumOfMenuCols
        break
      @_createCol i, menu, numOfItemsPerCol, menuItems

  _formatMenu: (navBarItemPos, el) ->
    menu = $(el).find('.menu')
    menuHoverContainer = $(el).find('.menu-hover-container')
    menuItems = menu.find('.menu-item')
    numOfItems = menuItems.length
    numOfCols = @_numOfCols numOfItems
    numOfItemsPerCol = @_numOfItemsPerCol numOfItems, numOfCols
    @_repositionMenu menu, menuHoverContainer, navBarItemPos, numOfItemsPerCol
    if numOfItems > @maxNumOfMenuItems
      menu.empty()
      @_updateMenuWidth menu, numOfCols
      @_createCols numOfCols, menu, numOfItemsPerCol, menuItems
    menuHoverContainer.height(menu.outerHeight())

  _appendL2Category: (menu, itemPos, el, menuItems) ->
    navBarLabel = $(el).find('.nav-bar-label')
    bhc = navBarLabel.attr('data-bhc')
    title = navBarLabel.text().trim()
    url = $(el).find('a').attr('href')
    menu.append("<li class='menu-item' data-bhc='#{bhc}'><a href='#{url}'>#{title}</a></li>")
    li = $(menu.find('li')[itemPos])
    menuItems.push li

  _moreCategoriesNavBarItem: (el) ->
    $(el).attr('id', @moreCategoriesId)
    moreCategoriesLink = $(el).find('a')[0]
    $(moreCategoriesLink).removeAttr('href')
    moreCategoriesLabel = $(el).find('.nav-bar-label')
    $(moreCategoriesLabel).attr('data-bhc', 'category:' +  @moreCategoriesId)
    $(moreCategoriesLabel).attr('data-bhc-path', 'LeftNavCategories|category:' + @moreCategoriesId)
    $(moreCategoriesLabel).html(@moreCategoriesLabel)

  _moreCategoriesMenu: (moreCategories) ->
    numOfItems = moreCategories.length
    numOfCols = @_numOfCols numOfItems
    numOfItemsPerCol = @_numOfItemsPerCol numOfItems, numOfCols
    menu = $('#' + @moreCategoriesId).find('.menu')
    menuHoverContainer = $('#' + @moreCategoriesId).find('.menu-hover-container')
    menu.attr('class', 'menu arrow').empty()
    menuItems = []
    for i in [0..numOfItems-1]
      @_appendL2Category menu, i, moreCategories[i], menuItems
    @_createCols numOfCols, menu, numOfItemsPerCol, menuItems
    @_repositionMenu menu, menuHoverContainer, @maxNumOfSubnavItems - 1, numOfItemsPerCol

  _loadSubnav: ->
    moreCategories = []
    navBarItems = $('.nav-bar-item')
    lastl2CategorySlot = @maxNumOfSubnavItems - 1
    hasMoreCategories = navBarItems.length > @maxNumOfSubnavItems
    for el, i in navBarItems
      if hasMoreCategories and i >= lastl2CategorySlot
        moreCategories.push $(el).clone()
        if i == lastl2CategorySlot
          @_moreCategoriesNavBarItem el
        else
          $(el).remove()
      @_formatMenu i, el
    if moreCategories.length > 0
      @_moreCategoriesMenu moreCategories
